import { render, staticRenderFns } from "./createNewApplication.vue?vue&type=template&id=3b0cedfe"
import script from "./createNewApplication.ts?vue&type=script&lang=js&external"
export * from "./createNewApplication.ts?vue&type=script&lang=js&external"
import style0 from "./createNewApplication.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports